import { render, staticRenderFns } from "./HomeFeed.vue?vue&type=template&id=a353f098&scoped=true&"
import script from "./HomeFeed.vue?vue&type=script&lang=js&"
export * from "./HomeFeed.vue?vue&type=script&lang=js&"
import style0 from "./HomeFeed.vue?vue&type=style&index=0&id=a353f098&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a353f098",
  null
  
)

export default component.exports